import { FC } from "react";
import "./style.scss";
import { admissionDatabaseBaseUrl } from "@/src/api/axiosInstance";
import backForDocEmpty from "@/src/assets/admissionOfficePage/back-for-doc-empty.png";

interface IAOPPrev {
  documentsPDFPath: string;
}

const AOPPrev: FC<IAOPPrev> = ({ documentsPDFPath }) => {
  return (
    <div className="admission-office-prev-wrapper">
      <div className="admission-office-prev documents-qr-code">
        {!documentsPDFPath ? (
          <img className="admission-office-prev-background" src={backForDocEmpty} alt={`${backForDocEmpty}`} />
        ) : (
          <iframe
            key={documentsPDFPath}
            src={`${admissionDatabaseBaseUrl}${documentsPDFPath}#toolbar=0&navpanes=0&scrollbar=0`}
            className="pdf-preview-frame"
            title="PDF Preview"
            width="100%"
            height="100%"
          />
        )}
      </div>
    </div>
  );
};

export default AOPPrev;
